export class UploadProgress {
    constructor(public start: number, public current: number, public url?: string) {}

    get percentage() {
        return (this.start / (this.start - this.current)) * 100
    }
}
